module.exports = __webpack_public_path__ + "img/touxiang.cad50d63.png";